import { Box, Skeleton, Stack } from "@mui/material";

const RelatedWikifolioCardSkeleton = () => (
    <Box
        sx={{
            display: "flex",
            width: "100%",
            height: "64px",
            boxShadow: 2,
            bgcolor: "white",
            borderRadius: "8px",
            padding: 2,
            alignItems: "center",
            justifyContent: "space-between",
        }}
    >
        <Box
            sx={{
                display: "flex",
                gap: 1,
                alignItems: "center",
            }}
        >
            <Skeleton variant="circular" width={32} height={32} sx={{ flexShrink: 0 }} />
            <Skeleton variant="rounded" width={120} height={16} />
        </Box>
        <Skeleton variant="rounded" width={60} height={24} sx={{ borderRadius: "100px" }} />
    </Box>
);

export const RelatedWikifoliosLoading = () => {
    return (
        <Box
            sx={{
                mt: [2, 2, 0],
            }}
        >
            <Skeleton variant="rounded" width={140} height={20} sx={{ mb: 2 }} />
            <Stack
                sx={{
                    gap: 1,
                }}
            >
                <RelatedWikifolioCardSkeleton />
            </Stack>
            <Box
                sx={{
                    textAlign: "right",
                    mt: 2,
                }}
            >
                <Skeleton variant="rounded" width={100} height={16} sx={{ ml: "auto" }} />
            </Box>
        </Box>
    );
};
